/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { OnmaxContext } from "../OnmaxContext";

export default function Affiliate() {
  const [isRegister, setIsRegister] = useState(false);
  const navigate = useNavigate();
  const { toastSuccess, toastError } = useContext(OnmaxContext);

  // Register States
  const [referral, setReferral] = useState("");
  const [telegram, setTelegram] = useState(""); // Email ID
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isRegistering, setIsRegistering] = useState(false);

  // Login States
  const [loginTelegram, setLoginTelegram] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const username = params.get("username");
    const password = params.get("password");
    if (username) setLoginTelegram(username);
    if (password) setLoginPassword(password);
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) return toastError("Passwords do not match");

    try {
      setIsRegistering(true);
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "insert",
        key: process.env.REACT_APP_KEY,
        ref_address: referral,
        fromname: name,
        email: telegram,
        password: password,
      });

      const result = res.data;
      if (result.resCode !== 200) {
        toastError(result.error);
        return;
      }

      toastSuccess(result.message || "Registered Successfully");
      localStorage.setItem("email", telegram);
      setTimeout(() => navigate("/verify"), 2000);

    } catch (error) {
      toastError(error.response?.data?.message || "Error during registration");
    } finally {
      setIsRegistering(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (isLoggingIn) return;
    setIsLoggingIn(true);
    await new Promise((resolve) => setTimeout(resolve, 500));

    try {
      // console.log("process.env.REACT_APP_BACKEND_LINK : ", process.env.REACT_APP_BACKEND_LINK);

      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "log",
        username: loginTelegram,
        password: loginPassword,
        key: process.env.REACT_APP_KEY,
      }, { withCredentials: true }
      );

      const result = res.data;
      // console.log("DATA", result);
      if (result.resCode === 300) {
        toastError(result.error);
        navigate('/loginChangePS');
        return;
      }
      if (result.resCode !== 200) {
        toastError(result.error);
        return;
      }

      toastSuccess(result.message);
      localStorage.setItem("token", result.token);
      localStorage.setItem("username", loginTelegram);
      navigate("/dashboard");

    } catch (err) {
      toastError("Server error occurred");
    } finally {
      setIsLoggingIn(false);
    }
  };

  const customStyles = `    /* --- FULL BODY EFFECTIVE ANIMATION --- */
    .ai-auth-container {
        min-height: 100vh;
        background: linear-gradient(-45deg, #e0f2fe, #f0f9ff, #dbeafe, #eff6ff);
        background-size: 400% 400%;
        animation: gradientBG 15s ease infinite;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
        position: relative;
        overflow: hidden;
    }
    
    @keyframes gradientBG {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
    }
    
    .ai-auth-container::before {
        content: '';
        position: absolute; top:0; left:0; width:100%; height:100%;
        background-image: radial-gradient(circle at 20% 50%, rgba(59, 130, 246, 0.08) 0%, transparent 40%),
                          radial-gradient(circle at 80% 80%, rgba(14, 165, 233, 0.08) 0%, transparent 40%);
        animation: pulseBubble 6s ease-in-out infinite alternate;
        z-index: 0; pointer-events: none;
    }

    @keyframes pulseBubble {
        0% { transform: scale(1); opacity: 0.6; }
        100% { transform: scale(1.5); opacity: 1; }
    }
    
    /* Effective background animation - Floating Glass Elements */
    .glass-square {
       position: absolute;
       background: rgba(255, 255, 255, 0.3);
       backdrop-filter: blur(5px);
       -webkit-backdrop-filter: blur(5px);
       border: 1px solid rgba(255, 255, 255, 0.5);
       border-radius: 20px;
       animation: floatUp 15s linear infinite;
       bottom: -150px;
       z-index: 1;
       box-shadow: 0 8px 32px rgba(0, 111, 227, 0.1);
    }
    @keyframes floatUp {
       0% { transform: translateY(0) rotate(0deg); opacity: 0; }
       10% { opacity: 1; }
       90% { opacity: 1; }
       100% { transform: translateY(-1200px) rotate(360deg); opacity: 0; }
    }
    .glass-square:nth-child(1) { left: 10%; width: 80px; height: 80px; animation-duration: 20s; animation-delay: 0s; }
    .glass-square:nth-child(2) { left: 25%; width: 130px; height: 130px; animation-duration: 25s; animation-delay: 2s; }
    .glass-square:nth-child(3) { left: 65%; width: 60px; height: 60px; animation-duration: 17s; animation-delay: 4s; }
    .glass-square:nth-child(4) { left: 85%; width: 110px; height: 110px; animation-duration: 28s; animation-delay: 1s; }
    .glass-square:nth-child(5) { left: 45%; width: 75px; height: 75px; animation-duration: 22s; animation-delay: 6s; }

    .ai-auth-card {
        background: #ffffff;
        border-radius: 20px;
        padding: 40px;
        width: 100%;
        max-width: 480px;
        position: relative;
        z-index: 10;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(0, 0, 0, 0.05);
    }
    
    .ai-logo-glow {
        filter: drop-shadow(0 4px 10px rgba(0, 111, 227, 0.2));
        margin-bottom: 24px;
        transition: filter 0.3s;
        border-radius: 12px;
        position: relative; z-index: 10;
    }

    .ai-auth-title { color: #1a2234; text-align: center; font-size: 26px; font-weight: 800; margin-bottom: 8px; letter-spacing: 0.5px;}
    .ai-auth-subtitle { color: #64748b; text-align: center; font-size: 14px; margin-bottom: 32px; font-weight: 500;}

    /* Premium Light Input Wrapper */
    .db-input-wrapper {
      background: rgba(238, 242, 246, 0.5); 
      border-radius: 16px; 
      padding: 16px 20px; 
      border: 1px solid rgba(255, 255, 255, 0.8);
      box-shadow: 1px 20px 20px 0px #bfc9d8, 0 10px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 #ffffff;
      display: flex; align-items: center; gap: 12px;
      position: relative;
      transition: all 0.3s;
      margin-bottom: 24px;
    }
    .db-input-wrapper:focus-within {
       border-color: #006fe3;
    }

    .db-input {
      background: transparent !important; border: none !important; outline: none !important; width: 100%; font-weight: 700; color: #000000 !important; font-size: 15px;
    }
    .db-input::placeholder { color: #94a3b8; font-weight: 500; }
    
    /* Scrollable Privacy/Terms Box - LIGHT THEME (As requested by image layout) */
    .tc-scroll-container {
       border: 1px solid rgba(0, 111, 227, 0.15);
       border-radius: 12px;
       margin-bottom: 20px;
       overflow: hidden;
       box-shadow: 0 4px 15px rgba(0,0,0,0.02);
    }
    .tc-box {
       background: rgba(238, 242, 246, 0.7);
       padding: 20px;
       height: 160px;
       overflow-y: auto;
       color: #64748b;
       font-size: 13px;
       line-height: 1.6;
    }
    .tc-box::-webkit-scrollbar { width: 6px; }
    .tc-box::-webkit-scrollbar-track { background: transparent; }
    .tc-box::-webkit-scrollbar-thumb { background: #006fe3; border-radius: 10px; }
    .tc-title { color: #1a2234; font-weight: 800; font-size: 14px; margin-bottom: 12px; }

    /* Checkbox Block Area */
    .tc-check-area {
       display: flex; align-items: center; gap: 14px; 
       background: #ffffff;
       border: 1px solid rgba(0, 111, 227, 0.2);
       box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
       padding: 16px 20px;
       border-radius: 12px;
       margin-bottom: 30px;
    }

    .tc-check-label { 
      color: #475569; 
      font-size: 14px; 
      font-weight: 600; 
      cursor: pointer; 
      user-select: none; 
      margin: 0; 
    }
    
    .tc-check-link { 
      color: #006fe3; 
      text-decoration: none; 
      font-weight: 800; 
      margin-left: 5px; 
    }
    
    input[type="checkbox"].tc-checkbox {
      width: 20px; 
      height: 20px; 
      accent-color: #006fe3; 
      cursor: pointer; 
      margin: 0;
    }

    .db-modern-btn {
      background: linear-gradient(135deg, #006fe3, #005bb5);
      color: #fff; 
      border: none; 
      padding: 16px; 
      border-radius: 14px;
      font-weight: 700; 
      width: 100%; 
      font-size: 16px; 
      letter-spacing: 1px;
      box-shadow: 0 4px 15px rgba(0, 111, 227, 0.4); 
      transition: 0.3s; 
      text-transform: uppercase;
      display: flex; 
      align-items: center; 
      justify-content: center; 
      gap: 8px;
    }

    .db-modern-btn:hover { 
      transform: translateY(-2px); 
      box-shadow: 0 8px 25px rgba(0, 111, 227, 0.5); 
    }

    .db-modern-btn:disabled { 
      opacity: 0.7; 
      cursor: not-allowed; 
    }

    .ai-switch-text { 
      text-align: center; 
      margin-top: 24px; 
      color: #64748b; 
      font-size: 14px; 
      font-weight: 600;
    }

    .ai-switch-link { 
      color: #006fe3; 
      font-weight: 800; 
      cursor: pointer; 
      margin-left: 5px; 
      text-decoration: none; 
    }
    
    .ai-switch-link:hover { 
      text-decoration: underline; 
    }
  `;

  return (
    <>
      <style>{customStyles}</style>
      <div className="ai-auth-container">
        {/* Floating Animation Elements */}
        <div className="glass-square"></div>
        <div className="glass-square"></div>
        <div className="glass-square"></div>
        <div className="glass-square"></div>
        <div className="glass-square"></div>

        {/* Brand Logo */}
        <div className="text-center">
          <img
            src="assets/logo_dark.svg"
            alt="GetLink Logo"
            className="ai-logo-glow"
            width="180"
          />
        </div>

        <div className="ai-auth-card">

          <h2 className="ai-auth-title">
            {isRegister ? "Create Account" : "Welcome Back"}
          </h2>
          <p className="ai-auth-subtitle">
            {isRegister ? "Sign up to start your journey" : "Enter your credentials to access account"}
          </p>

          {isRegister ? (
            /* REGISTER FORM */
            <form onSubmit={handleRegister}>
              <div className="db-input-wrapper">
                <span className="db-input-icon-box icon-slate">
                  <i className="fa fa-user-plus"></i>
                </span>
                <input
                  className="db-input fw-bold"
                  type="text"
                  placeholder="Referral ID"
                  value={referral}
                  onChange={(e) => setReferral(e.target.value)}
                />
              </div>

              <div className="db-input-wrapper">
                <span className="db-input-icon-box icon-cyan">
                  <i className="fa fa-envelope"></i>
                </span>
                <input className="db-input cw-bold"
                  type="text"
                  placeholder="Email Address"
                  value={telegram}
                  onChange={(e) => setTelegram(e.target.value)}
                  required
                />
              </div>

              <div className="db-input-wrapper">
                <span className="db-input-icon-box icon-blue">
                  <i className="fa fa-user"></i>
                </span>
                <input className="db-input fw-bold"
                  type="text"
                  placeholder="Full Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="db-input-wrapper">
                <span className="db-input-icon-box icon-cyan">
                  <i className="fa fa-lock"></i>
                </span>
                <input className="db-input fw-bold"
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <div className="db-input-wrapper">
                <span className="db-input-icon-box icon-slate">
                  <i className="fa fa-shield-alt"></i>
                </span>
                <input
                  className="db-input fw-bold"
                  type="password"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>

              {/* T&C Scrollable Policy Box */}
              <div className="tc-scroll-container">
                <div className="tc-box">
                  <div className="tc-title">Terms & Conditions – Investment Disclaimer</div>
                  Cryptocurrency investments are subject to high market risks, including the possible loss of invested capital. Returns are not guaranteed, and past performance does not represent or assure future results. Digital asset prices may be highly volatile and can fluctuate significantly due to market conditions, regulatory changes, and other external factors. <br /><br />
                  Investors are strongly advised to carefully read all scheme-related documents, understand the associated risks, and conduct their own independent research before making any decisions. By proceeding, you acknowledge these risks and agree to our privacy policies.
                </div>
              </div>

              {/* Checkbox separate block */}
              <div className="tc-check-area">
                <input type="checkbox" id="tcCheck" className="tc-checkbox" required />
                <label htmlFor="tcCheck" className="tc-check-label">
                  I accept the <span className="tc-check-link">Terms & Conditions</span>
                </label>
              </div>

              <button type="submit" className="db-modern-btn" disabled={isRegistering}>
                {isRegistering ? "Creating Account..." : "Sign Up"}
              </button>

              <div className="ai-switch-text">
                Already have an account?
                <span className="ai-switch-link" onClick={() => setIsRegister(false)}>Log in</span>
              </div>
            </form>
          ) : (
            /* LOGIN FORM */
            <form onSubmit={handleLogin}>

              <div className="db-input-wrapper">
                <span className="db-input-icon-box icon-blue">
                  <i className="fa fa-user"></i>
                </span>
                <input
                  className="db-input fw-bold"
                  type="text"
                  placeholder="Username"
                  value={loginTelegram}
                  onChange={(e) => setLoginTelegram(e.target.value)} style={{ border: "none", outline: "none", boxShadow: "none", color: "#000" }}

                  required
                />
              </div>

              <div className="db-input-wrapper">
                <span className="db-input-icon-box icon-cyan">
                  <i className="fa fa-lock"></i>
                </span>
                <input
                  className="db-input fw-bold"
                  type="password"
                  placeholder="Password"
                  value={loginPassword} style={{ border: "none", outline: "none", boxShadow: "none", color: "#000" }}

                  onChange={(e) => setLoginPassword(e.target.value)}
                  required
                />
              </div>
              {/* FIXED FORGOT PASSWORD */}
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "4px", marginBottom: "16px" }}>
                <span
                  style={{
                    fontSize: "15px",        // bigger text
                    color: "#072249",
                    cursor: "pointer",
                    transition: "0.2s",
                    fontWeight: "700",       // ✅ proper bold
                  }}
                  onClick={() => navigate('/loginChangePS')}
                  onMouseEnter={(e) => (e.target.style.color = "#2563eb")}
                  onMouseLeave={(e) => (e.target.style.color = "#072249")}
                >
                  Forgot Password?
                </span>
              </div>

              <button type="submit" className="db-modern-btn" disabled={isLoggingIn}>
                {isLoggingIn ? (
                  <>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span>Logging in...</span>
                  </>
                ) : "Sign In"}
              </button>

              <div className="ai-switch-text">
                Don't have an account?
                <span className="ai-switch-link" onClick={() => setIsRegister(true)}>Sign Up</span>
              </div>
            </form>
          )}

        </div>

        <div style={{ position: 'absolute', bottom: 20, color: '#334155', fontSize: 12 }}>
          &copy; {new Date().getFullYear()} GetLinker. All rights reserved.
        </div>

      </div>
    </>
  );
}
